export default __webpack_public_path__ + "static/media/simplified-header.983d270d.svg";